import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';
import NotFound from '../views/NotFound.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '*',
    name: 'NotFound',
    component: NotFound,
  },
  {
    path: '/error',
    name: 'NotFound',
    component: NotFound,
  },
  {
    path: '/2015',
    name: 'Font2015',
    component: () => import(/* webpackChunkName: "font2014" */ '../views/Font2014.vue'),
  },
  {
    path: '/2022',
    name: 'Font2022',
    component: () => import(/* webpackChunkName: "font2021" */ '../views/Font2021.vue'),
  },
  {
    path: '/2023',
    name: 'Font2023',
    component: () => import(/* webpackChunkName: "font2021" */ '../views/Font2022.vue'),
  },
  {
    path: '/2024',
    name: 'Font2024',
    component: () => import(/* webpackChunkName: "font2021" */ '../views/Font2024.vue'),
  },
  {
    path: '/download',
    name: 'FontStore',
    component: () => import(/* webpackChunkName: "FontStore" */ '../views/FontStore.vue'),
  },
  {
    path: '/matter-test',
    name: 'MatterTest',
    component: () => import(/* webpackChunkName: "FontStore" */ '../components/MatterTest.vue'),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
